// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"2ccfa346","155":"119c2fd4","234":"33cbb044","284":"f9aeeb9b","420":"6a4d3a3e","453":"33dd4495","566":"1b626318","638":"d160db8b","647":"46ed70f5","840":"229882db"}[chunkId] + ".chunk.js";
};